import React from "react";
import VlogAllCategory from "@modules/study/vlog/vlog_category/vlog_all_category";
import { LayoutMain } from "@unisearch/theme/layout";
import API from "@unisearch/helpers/api";
import dynamic from "next/dynamic";

const VlogPlaylist = dynamic(
  () => import("@modules/study/vlog/components/playlist"),
  {
    ssr: false,
  }
);

const VlogCategory = ({ vlogCategories }) => {
  return (
    <LayoutMain
      title={"Vlog Categories"}
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/vlog/category`}
    >
      <VlogAllCategory vlogCategories={vlogCategories} />
      <VlogPlaylist />
    </LayoutMain>
  );
};

export default VlogCategory;

export async function getServerSideProps({ query }) {
  let props = {
    vlogCategories: "",
  };

  let page_limit = 20;
  let current_page = 1;

  const { limit, page } = query;

  if (limit && page) {
    page_limit = limit;
    current_page = page;
  } else {
    page_limit = 20;
    current_page = 1;
  }

  try {
    await API.get(
      `/public/vlog/category-list?limit=${page_limit}&page=${current_page}`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        props.vlogCategories = resp.data;
      } else {
        props.vlogCategories = "";
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
